import { makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { capitalize } from "../../utils/helpers";
import SignatureIcon from "@material-ui/icons/Gesture";
import CameraIcon from "@material-ui/icons/CameraAlt";
import VerifiedIcon from "@material-ui/icons/HowToReg";

const useStyles = makeStyles(theme => ({
  requirementIcon: {
    fontSize: "0.9375rem",
    marginRight: theme.spacing(0.75),
    color: "#808080"
  },
  dashIcon: {
    fontSize: "0.8125rem",
    color: "#808080"
  },
  requirementsWrapper: {
    display: "flex",
    alignItems: "center",
    height: "15px"
  }
}));

export default function StopRequirements({ stop }) {
  const classes = useStyles();

  return (
    <>
      <Typography variant="body2">{capitalize(stop.type)}</Typography>
      <div className={classes.requirementsWrapper}>
        {stop.requirements && (
          <>
            {(stop.requirements.signature || stop.signature) && (
              <SignatureIcon className={classes.requirementIcon} />
            )}

            {/* Use when barcode requirement will be added */}
            {/* {(stop.requirements.barcode || stop.barcodes_scanned) && (
             <BarcodeIcon className={classes.requirementIcon} />
           )} */}

            {(stop.requirements.age_verification || stop.age_verified) && (
              <VerifiedIcon className={classes.requirementIcon} />
            )}

            {(stop.requirements.picture || !!stop.images?.length) && (
              <CameraIcon className={classes.requirementIcon} />
            )}

            {/* No requirements */}
            {!(stop.requirements.signature || stop.signature) &&
            !(stop.requirements.age_verification || stop.age_verified) &&
            !(stop.requirements.picture || !!stop.images?.length) ? (
              <span className={classes.dashIcon}>—</span>
            ) : null}
          </>
        )}
      </div>
    </>
  );
}
